<template>
  <div>
    <CRow class="content-fade-in">
      <CCol md="12">
        <CCard>
          <CCardBody>
            <CForm class="form-basic">
              <CRow>
                <CCol sm="12" md="12" xl="12">
                  <BaseInput :options="nameInput.options" :data="nameInput.data" :listener="nameInput.listener" />
                </CCol>
                <CCol sm="12" md="12" xl="12">
                  <BaseSelect :options="typeSelect.options" :data="typeSelect.data" ref="typeSelect">
                  </BaseSelect>
                </CCol>
                <CCol sm="12" md="12" xl="12">
                  <div class="form-group">
                    <label>Chọn bản tin</label>
                    <br />
                    <CButton :disabled="typeSelect.data.model == ''" color="primary" class="btn-action-primary mr-2"
                      @click="chooseFile()">
                      <i class="fa fa-file"></i> Chọn bản tin
                    </CButton>
                  </div>
                </CCol>
                <CCol v-if="typeSelect.data.model == '0' || typeSelect.data.model == '1'" sm="12" md="6" xl="6">
                  <BaseSelect :options="animateInSelect.options" :data="animateInSelect.data" ref="animateInSelect">
                  </BaseSelect>
                </CCol>
                <CCol v-if="typeSelect.data.model == '0' || typeSelect.data.model == '1'" sm="12" md="6" xl="6">
                  <BaseSelect :options="animateOutSelect.options" :data="animateOutSelect.data" ref="animateOutSelect">
                  </BaseSelect>
                </CCol>
                <CCol sm="12" md="12" xl="12" class="mt-4">
                  <div class="form-group">
                    <label>Danh sách bản tin <span class="required">*</span></label>
                    <div class="valid-error" v-show="
                      !(selectedFiles.data.validator
                        ? selectedFiles.data.validator.isValid
                        : true)
                    ">
                      {{
                      selectedFiles.data.validator
                      ? selectedFiles.data.validator.errorMessage
                      : ""
                      }}
                    </div>
                    <br />
                    <CDataTable :items="selectedFiles.data.model" :fields="chooseFileTable.options.fields"
                      :sorterValue="{ column: null, asc: 'true' }">
                      <template #name="{ item }">
                        <td>{{ item.name }}</td>
                      </template>
                      <template #action="{ index }">
                        <td class="action-btn-group">
                          <div class="action-btn-wrapper">
                            <CButton color="info" variant="outline" v-c-tooltip.hover="'Lên vị trí'" square size="sm"
                              :disabled="index === 0" @click="changeIndexFile(index, 'up')">
                              <CIcon name="cil-arrow-top" />
                            </CButton>
                            <CButton color="info" variant="outline" class="ml-1" square size="sm" :disabled="
                              index === selectedFiles.data.model.length - 1
                            " @click="changeIndexFile(index, 'down')" v-c-tooltip.hover="'Xuống vị trí'">
                              <CIcon name="cil-arrow-bottom" />
                            </CButton>
                            <CButton color="danger" variant="outline" class="ml-1" square size="sm"
                              @click="deleteFile(index)" v-c-tooltip.hover="'Xóa'">
                              <CIcon name="cil-trash" />
                            </CButton>
                          </div>
                        </td>
                      </template>
                      <template slot="no-items-view">
                        <span style="color: #969696">Danh sách trống!</span>
                      </template>
                      <template slot="loading">
                        <BaseLoading :loading="loading" />
                      </template>
                    </CDataTable>
                  </div>
                </CCol>
              </CRow>
              <br />
              <CRow>
                <CCol sm="6" md="6">
                  <CButton color="primary" class="btn-action-primary mr-2" @click="submitData">
                    <i class="fa fa-plus"></i> Thêm mới
                  </CButton>
                  <CButton color="secondary" class="btn-action-primary mr-2" @click="resetData()"><i
                      class="fa fa-eraser"></i> Làm mới
                  </CButton>
                  <CButton color="secondary" class="btn-action-primary mr-2" @click="$router.go(-1)"><i
                      class="fa fa-reply"></i> Hủy bỏ
                  </CButton>
                  <CButton v-if="selectedFiles.data.model.length > 0 && (typeSelect.data.model == '0' || typeSelect.data.model == '1')" color="success" class="btn-action-primary mr-2" @click="preview()"><i class="fa fa-eye"></i>
                    Xem trước
                  </CButton>
                </CCol>
              </CRow>
              <BaseLoading :loading="loading.value"></BaseLoading>
            </CForm>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>

    <ChooseFilePopup v-if="isShowChooseFilePopup" :items="selectedFiles.data.model" :type="typeSelect.data.model"
                      @updateIsShowChooseFilePopup="updateShowChooseFilePopup" 
                      @updateSelectedFiles="updateSelectedFiles">
    </ChooseFilePopup>

    <PreviewPlayList v-if="selectedFiles.data.model.length > 0 && isShowPopupPlayList" :isShow="isShowPopupPlayList"
      :items="selectedFiles.data.model" :animateIn="animateInStyle" :animateOut="animateOutStyle"
      :type="typeSelect.data.model" @updateIsShowPopupPlayList="updateIsShowPopupPlayList"></PreviewPlayList>
  </div>
</template>

<script>
import BaseSelect from "../base/BaseSelect2";
import BaseInput from "../base/BaseInput";
import BaseLoading from "../base/BaseFormLoading";
import Multiselect from "vue-multiselect";
import { USER_NAME } from '../../constant';
import PreviewPlayList from './PreviewPlayList';
import ChooseFilePopup from './ChooseFilePopup';

export default {
  name: "PlayListAdd",
  components: { BaseSelect, BaseInput, BaseLoading, Multiselect, PreviewPlayList, ChooseFilePopup },
  notifications: {
    showSuccessMsg: {
      type: "success",
      title: "Success",
    },
    showErrorMsg: {
      type: "error",
      title: "Errors",
    },
    showWarningMsg: {
      type: "warn",
      title: "warn",
    },
  },
  data: function () {
    let that = this;
    return {
      loading: { value: false },
      isShowChooseFilePopup: false,
      animateInStyle: "",
      animateOutStyle: "",
      itemsAnimateIn: [],
      itemsAnimateOut: [],
      isShowPopupPlayList: false,
      animateInSelect: {
        options: {
          label: "Hiệu ứng bắt đầu",
          filter: true,
          keyField: "value",
          valueField: "text",
          selectAllText: "Chọn hiệu ứng",
        },
        data: {
          model: "",
          updateCallback: function () {
            that.submitData();
          },
          name: "animateInId",
          source: {
            dataSubmit: function () {
              return {
                type: 1
              };
            },
            url: "/animate/find-all-by-type",
            response: function (dataResponse) {
              that.itemsAnimateIn = dataResponse.data;
              return dataResponse.data;
            },
          },
        },
      },
      animateOutSelect: {
        options: {
          label: "Hiệu ứng kết thúc",
          filter: true,
          keyField: "value",
          valueField: "text",
          selectAllText: "Chọn hiệu ứng",
        },
        data: {
          model: "",
          updateCallback: function () {
            that.submitData();
          },
          name: "animateOutId",
          source: {
            dataSubmit: function () {
              return {
                type: 2
              };
            },
            url: "/animate/find-all-by-type",
            response: function (dataResponse) {
              that.itemsAnimateOut = dataResponse.data;
              return dataResponse.data;
            },
          },
        },
      },
      // chooseFileData: {
      //   fileInput: {
      //     data: {
      //       name: "fileIds",
      //       model: [],
      //       items: [],
      //       validator: {
      //         isValid: true,
      //         errorMessage: "",
      //         valid: function () {
      //           let value = that.chooseFileData.fileInput.data.model;
      //           if (!value || value.length === 0) {
      //             this.isValid = false;
      //             this.errorMessage = "Bản tin không được để trống";
      //           } else {
      //             this.isValid = true;
      //           }
      //           return this.isValid;
      //         },
      //       },
      //     },
      //   },
      // },
      nameInput: {
        options: {
          label: "Tên danh sách <span class='required'>*</span>",
          placeholder: "Tên danh sách",
          type: "text",
        },
        data: {
          name: "name",
          model: "",
          updateCallback: function () {
            that.submitData();
          },
          validator: {
            isValid: true,
            errorMessage: "",
            valid: function () {
              let value = that.nameInput.data.model;
              if (value === "") {
                this.isValid = false;
                this.errorMessage = "Tên danh sách không được để trống";
              } else {
                this.isValid = true;
                this.errorMessage = "";
              }
              return this.isValid;
            },
          },
        },
      },
      typeSelect: {
        options: {
          filter: false,
          label: "Loại danh sách <span class='required'>*</span>",
          selectAllText: "Chọn loại danh sách"
        },
        data: {
          name: "type",
          items: [
            { key: "-1", value: "Chữ chạy" },
            { key: "0", value: "Văn bản" },
            { key: "1", value: "Hình ảnh" },
            { key: "2", value: "Video" },
            { key: "4", value: "Tài liệu" },
          ],
          model: "",
        },
      },
      selectedFiles: {
        data: {
          name: "files",
          model: [],
          validator: {
            isValid: true,
            errorMessage: "",
            valid: function () {
              let value = that.selectedFiles.data.model;
              if (value.length == 0) {
                this.isValid = false;
                this.errorMessage = "Danh sách bản tin không được để trống";
              } else {
                this.isValid = true;
                this.errorMessage = "";
              }
              return this.isValid;
            },
          },
        },
      },
      chooseFileTable: {
        options: {
          fields: [
            { key: "name", label: "Tên bản tin", _style: "width: 40%;" },
            { key: "action", label: "Thao tác", _style: "width: 10%;" },
          ],
          slots: ["index", "name", "action"],
        },
      },
    };
  },
  methods: {
    changeIndexFile(index, type) {
      this.loading.value = true;
      if (type == "up") {
        this.arrayMove(index, index - 1);
      } else if (type == "down") {
        this.arrayMove(index, index + 1);
      }
    },
    async deleteFile(index) {
      let that = this;
      that.loading.value = true;
      that.selectedFiles.data.model.splice(index, 1);
      that.loading.value = false;
    },
    async arrayMove(old_index, new_index) {
      let data = this.selectedFiles.data.model;
      Promise.all(
        (function* () {
          yield new Promise((resolve) => {
            if (new_index >= data.length) {
              let k = new_index - data.length + 1;
              while (k--) {
                data.push(undefined);
              }
            }
            data.splice(new_index, 0, data.splice(old_index, 1)[0]);
            resolve(data);
          });
        })()
      )
        .then(() => {
          this.loading.value = false;
          this.selectedFiles.data.model = data
        })
        .catch((error) => {
          console.log(error);
        });
    },
    resetData() {
      this.nameInput.data.model = "";
      this.typeSelect.data.model = "";
      this.selectedFiles.data.model = [];
    },
    chooseFile: function () {
      // this.chooseFileData.fileInput.data.model = [];
      // this.loadDataFile();
      this.isShowChooseFilePopup = true;
    },
    preview: function () {
      this.isShowPopupPlayList = true;
    },
    submitData: function () {
      let that = this;
      let isValid = true;
      isValid &= that.nameInput.data.validator.valid();
      isValid &= that.selectedFiles.data.validator.valid();

      if (!isValid) {
        return;
      }
      for (var i = 0; i < that.selectedFiles.data.model.length; i++) {
        that.selectedFiles.data.model[i].index = i;
      }

      that.$helper.loadDataSource({
        loading: that.loading,
        url: "/play-list/add",
        dataSubmit: function () {
          return {
            name: that.nameInput.data.model,
            type: that.typeSelect.data.model,
            playListDetailModels: that.selectedFiles.data.model,
            animateInId: that.animateInSelect.data.model,
            animateOutId: that.animateOutSelect.data.model,
            userName: localStorage.getItem(USER_NAME)
          };
        },
        successCallback: function (response) {
          if (!that.$helper.validResponse(that.$router, response.data)) {
            that.showErrorMsg({
              message: that.$helper.getStringError(response.data.data),
            });
            that.$helper.setupErrorModel(response.data.data, that.$data);
          } else {
            that.showSuccessMsg({
              message: "Thêm mới danh sách phát thành công",
            });
            that.$router.push("/files-screen-management/play-list.html");
          }
        },
        errorCallback: function (error) {
          that.$helper.handleError(that.$router, error);
        },
      });
    },
    updateIsShowPopupPlayList: function (value) {
      let that = this;
      that.isShowPopupPlayList = value
    },
    updateShowChooseFilePopup: function (value) {
      this.isShowChooseFilePopup = value
    },
    updateSelectedFiles: function (value) {
      let that = this;
      that.selectedFiles.data.model = that.selectedFiles.data.model.concat(value);
    }
  },
  computed: {},
  created() {
  },
  mounted() {
  },
  watch: {
    'typeSelect.data.model': function () {
      this.selectedFiles.data.model = [];
    },
    'animateInSelect.data.model': function (value) {
      if(value) {
        let animate = this.itemsAnimateIn.filter(item => item.value == value)[0];
        if(animate) {
          this.animateInStyle = animate.type;
        }
      }
    },
    'animateOutSelect.data.model': function (value) {
      if(value) {
        let animate = this.itemsAnimateOut.filter(item => item.value == value)[0];
        if(animate) {
          this.animateOutStyle = animate.type;
        }
      }
    }
  },
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css">

</style>
<style>
.multiselect.input-error .multiselect__tags {
  border-color: #ff7070;
}

.vc-date {
  display: none !important;
}

.multiselect,
.multiselect .multiselect__tags {
  height: 36px !important;
  min-height: 36px !important;
}

.multiselect__input {
  line-height: unset !important;
  padding-left: 1px !important;
  font-size: 14px !important;
}

.multiselect .multiselect__tags {
  padding-top: 4px !important;
}

.multiselect .multiselect__tag {
  margin-top: 2px !important;
}
</style>
